import { createSimpleDictionary } from '@/stores/utils/createSimpleDictionary';

export const customerPlDatePeriodDictionary = createSimpleDictionary([
    { id: 'lifetime', name: 'customerPl.datePeriod.lifetime' },
    { id: '360', name: 'customerPl.datePeriod.days360' },
    { id: '90', name: 'customerPl.datePeriod.days90' },
    { id: '60', name: 'customerPl.datePeriod.days60' },
    { id: '30', name: 'customerPl.datePeriod.days30' },
    { id: 'range', name: 'customerPl.datePeriod.range' },
]);
